import { HiOutlineLightBulb } from "react-icons/hi"; // Note Icon
import cosmetics from "../assets/exp/cosmetics.jpg";
import rotations from "../assets/exp/itemrotation.jpg";
import PerArenaGenerator from "../assets/exp/perarenagen.png";
import ProjectCard from "./ui/ProjectCard";
import { IoLogoGithub } from "react-icons/io";

const Projects = () => {
  return (
    <div
      id="projects"
      className="mx-auto flex flex-col justify-center gap-16 px-4 sm:px-6 py-24 md:items-center max-w-5xl"
    >
      <div className="text-center space-y-2 mb-6">
        <h2 className="text-indigo-400 font-mono text-xs uppercase tracking-widest font-bold">Featured Creations</h2>
        <h1 className="text-3xl font-extrabold text-white sm:text-4xl tracking-tight">
          Famous Projects
        </h1>
      </div>

      {/* RECENT PROJECTS */}
      <div className="w-full flex flex-col gap-12">
        <ProjectCard
          title="BedWars Cosmetics"
          subtitle="SpigotMC Plugin (Java)"
          description="An addon for the supported BedWars plugin that adds various cosmetics such as Sprays, Glyphs, Victory Dances, ShopKeeperSkins, and Kill Messages! Inspired by Hypixel Network."
          picture={cosmetics}
          github="https://github.com/IamTheDefender/BedWars-Cosmetics"
          website="https://www.spigotmc.org/resources/bedwars-cosmetics.106685/"
          tools={[]}
        />
        <ProjectCard
          title="Item Rotation"
          subtitle="SpigotMC Plugin (Java)"
          description="An addon for BedWars1058 (as of Feb. 2024) that introduces a shop category with special rotating items such as unicorn item and ice bridge. Inspired by Hypixel Network."
          picture={rotations}
          github="https://github.com/IamTheDefender/BedWars1058-ItemRotation"
          website="https://www.spigotmc.org/resources/item-rotation-bw1058.107016/"
          tools={[]}
          isImageOnLeft={true}
        />
        <ProjectCard
          title="PerArenaGenerator"
          subtitle="SpigotMC Plugin (Java)"
          description="Adds the ability to have multiple generator speed configurations per group instead of a global setting. Very lightweight."
          picture={PerArenaGenerator}
          website="https://polymart.org/resource/bedwars1058-perarenagen.2815"
          tools={[]}
        />
      </div>

      {/* 🔥 CHECK OUT OTHER PROJECTS SECTION */}
      <div className="w-full max-w-xl mx-auto mt-6">
        <div className="card-flat p-8 flex flex-col items-center gap-4 text-center">
          <div className="p-3 rounded-lg bg-slate-950 border border-slate-800 text-slate-400">
            <HiOutlineLightBulb size={24} />
          </div>
          <h2 className="text-lg font-bold text-white tracking-tight">Explore More Projects</h2>
          <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
            While I've contributed to <strong className="font-semibold text-white">100+ client projects</strong>, 
            many remain private. Discover my public work on GitHub!
          </p>
          <a
            href="https://github.com/IamTheDefender"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-flex items-center gap-2 px-4 py-2 text-xs font-bold text-slate-200 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded-lg transition-colors"
          >
            <IoLogoGithub className="text-base" />
            <span>View GitHub Profile</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Projects;

